import styled from 'styled-components';
import { getTheme } from '../../theme';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${props => getTheme(props.theme?.isDark).colors.surfaceElevated};
  border-radius: ${props => getTheme(props.theme?.isDark).borderRadius.md};
  overflow: hidden;
  border: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
`;

export const TableHead = styled.thead`
  background-color: ${props => getTheme(props.theme?.isDark).colors.surface};
  ${props => props.theme?.isDark && `
    box-shadow: 0 2px 4px rgba(0, 255, 0, 0.1);
  `}
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => getTheme(props.theme?.isDark).colors.hover};
    ${props => props.theme?.isDark && `
      box-shadow: 0 0 10px rgba(0, 255, 0, 0.1);
    `}
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeader = styled.th`
  padding: ${props => getTheme(props.theme?.isDark).spacing.md};
  text-align: left;
  font-weight: 600;
  color: ${props => getTheme(props.theme?.isDark).colors.text};
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TableCell = styled.td`
  padding: ${props => getTheme(props.theme?.isDark).spacing.md};
  color: ${props => getTheme(props.theme?.isDark).colors.text};
  font-size: 14px;
`;

export const TableBody = styled.tbody``;


